<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div class="bg-white classen__rounded w-9/10 1.5xl:w-5/10 h-8/10 4k:h-1/2 px-5 py-10 4k:px-20">

      <div :class="{'header':state === 0, 'small_header': state !== 0}" class="mb-4">
        <div class="w-full text-right">
          <div @click="$emit('close')" class="cursor-pointer text-gray-50 text-lg  4k:text-4xl"><i
            class="fas fa-times"></i></div>
        </div>
        <p class="text-2xl font-bold text-center -mt-8 4k:text-5xl">{{
            getTranslation('createAmbienceImage')
          }}</p>
        <div v-if="state===0">
          <p class="mb-2">{{ getTranslation('currentSelection') }}: {{ selection.name }}</p>
          <p class="mb-2">{{ getTranslation('user') }}:
            {{ $dashboardStore.getters.getActiveUser().name }}</p>
        </div>
      </div>

      <div v-if="state === 0" class="overflow-y-auto content pr-1 4k:mt-20">
        <div class="flex flex-wrap justify-between mb-4">
          <p class="w-1/10 text-sm 4k:text-lg">
            {{ getTranslation('medium') }}:
            <span class="text-red-600">*</span>
          </p>
          <div class="w-9/10 flex">
            <div class="flex option_item w-2/10" @click="media = 'web'">
              <c-checkBox :selected="media === 'web'"/>
              <label class="text-sm 4k:text-lg option_item">{{ getTranslation('web') }}</label>
            </div>
            <div class="flex option_item  w-2/10 ml-6" @click="media = 'print'">
              <c-checkBox :selected="media === 'print'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('print')
                }}</label>
            </div>
          </div>
        </div>
        <div v-if="media === 'web'">
          <div class="flex flex-wrap justify-between mb-4">
            <p class="w-1/10 text-sm 4k:text-lg">
              {{ getTranslation('resolution') }}:
              <span class="text-red-600">*</span>
            </p>
            <div class="w-9/10 flex">
              <div class="flex option_item w-2/10" @click="resolution = 'FHD'">
                <c-checkBox :selected="resolution === 'FHD'"/>
                <label class="text-sm 4k:text-lg option_item">FHD 1920x1080</label>
              </div>
              <div class="flex option_item  w-2/10 ml-6" @click="resolution = '4K'">
                <c-checkBox :selected="resolution === '4K'"/>
                <label class="text-sm 4k:text-lg option_item">4K 3840x2160</label>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap justify-between mb-4">
            <p class="w-1/10 text-sm 4k:text-lg">
              {{ getTranslation('orientation') }}:
              <span class="text-red-600">*</span>
            </p>
            <div class="w-9/10 flex">
              <div class="flex option_item w-2/10" @click="orientation = 'portrait'">
                <c-checkBox :selected="orientation === 'portrait'"/>
                <label class="text-sm 4k:text-lg option_item">{{
                    getTranslation('portrait')
                  }}</label>
              </div>
              <div class="flex option_item  w-2/10 ml-6" @click="orientation = 'landscape'">
                <c-checkBox :selected="orientation === 'landscape'"/>
                <label class="text-sm 4k:text-lg option_item">{{
                    getTranslation('landscape')
                  }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between mb-4">
          <p class="w-1/10 text-sm 4k:text-lg">
            {{ getTranslation('purpose') }}:
            <span class="text-red-600">*</span>
          </p>
          <c-input class="w-9/10" :idkey="0" v-model="purpose" :name="getTranslation('purpose')"
                   :has-error="!isValidPurpose && performedValidation"/>
        </div>
        <div class="flex flex-wrap justify-between mb-4">
          <p class="w-1/10 text-sm 4k:text-lg">
            {{ getTranslation('customer') + '/ ' + getTranslation('internal') }}:
            <span class="text-red-600">*</span>
          </p>
          <c-input class="w-9/10" :idkey="1" v-model="customerInter"
                   :name="getTranslation('purpose')"
                   :has-error="!isValidCustomer && performedValidation"/>
        </div>
        <div class="mb-6">
          <p class="w-1/10 text-sm 4k:text-lg mb-2">
            {{ getTranslation('laying') }}:
            <span class="text-red-600">*</span>
          </p>
          <div class="flex">
            <div class="flex option_item w-1/10" @click="laying = 'floor'">
              <c-checkBox :selected="laying === 'floor'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('floor')
                }}</label>
            </div>
            <div class="flex option_item w-1/10 ml-6" @click="laying ='wall'">
              <c-checkBox :selected="laying === 'wall'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('wall')
                }}</label>
            </div>
            <div class="flex option_item w-1/10 ml-6" @click="laying ='halfOffset'">
              <c-checkBox :selected="laying === 'halfOffset'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('halfOffset')
                }}</label>
            </div>
            <div class="flex option_item w-1/10 ml-6" @click="laying ='irregular'">
              <c-checkBox :selected="laying === 'irregular'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('irregular')
                }}</label>
            </div>
            <div class="flex option_item w-1/10 ml-6" @click="laying ='crossJoint'">
              <c-checkBox :selected="laying === 'crossJoint'"/>
              <label class="text-sm 4k:text-lg option_item">{{
                  getTranslation('crossJoint')
                }}</label>
            </div>
          </div>
        </div>
        <div class="mb-6">
          <p class="w-1/10 text-sm 4k:text-lg mb-2">
            {{ getTranslation('bevel') }}:
            <span class="text-red-600">*</span>
          </p>
          <div class="flex">
            <div class="flex option_item w-1/10" @click="bevel = '0V'">
              <c-checkBox :selected="bevel === '0V'"/>
              <label class="text-sm 4k:text-lg option_item">0V</label>
            </div>
            <div class="flex option_item  w-1/10 ml-6" @click="bevel = '2V'">
              <c-checkBox :selected="bevel === '2V'"/>
              <label class="text-sm 4k:text-lg option_item">2V</label>
            </div>
            <div class="flex option_item  w-1/10 ml-6" @click="bevel = '4V'">
              <c-checkBox :selected="bevel === '4V'"/>
              <label class="text-sm 4k:text-lg option_item">4V</label>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between mb-4">
          <p class="w-1/10 text-sm 4k:text-lg flex">
            {{ getTranslation('bevelColor') }}:
            <span class="text-red-600">*</span>
          </p>
          <select v-model="selectedBevelColor" class="w-9/10 bg-classen__secondary p-2">
            <option v-for="color in bevelColors">{{ color.name }}</option>
          </select>
        </div>
        <div class="mb-6">
          <p class="w-full text-sm 4k:text-lg mb-2"
             :class="{'text-red-600': !isTemplatesValid && performedValidation}">
            {{ getTranslation('imageTemplate') }}:
            <span class="text-red-600">*</span>
          </p>
          <div v-if="!loadingTemplates" class="flex flex-wrap gap-x-2 gap-y-4">
            <div v-for="(template, index) in templates" :id="index" class="template">
              <img :src="template.src"
                   class="asset_box text-2xl bg-classen__secondary classen__rounded flex items-center justify-center"
                   alt="template"/>
              <div
                class="delete relative cursor-pointer bg-classen__primary flex items-center justify-center text-white text-sm 4k:text-lg"
                @click="templates.splice(index,1)">
                <i class="fas fa-trash"></i>
              </div>
              <div v-for="(product, index) in template.products" class="w-full mt-2">
                <div
                  class="mt-2 bg-classen__secondary classen__rounded_full add_product_box text-2xl flex items-center justify-between">
                  <p class="text-base ml-2">{{ product.externalId }}</p>
                  <div
                    class="delete_product relative cursor-pointer bg-classen__primary flex items-center justify-center text-white text-sm 4k:text-lg"
                    @click="delete_product(template, index)">
                    <i class="fas fa-trash"></i>
                  </div>
                </div>
              </div>

              <c-product-picker class="w-full mt-2" @changedProduct="addProduct(template,$event)"
                                :products="products"></c-product-picker>
            </div>
            <div @click="isTemplatePickerVisible = true">
              <div
                class="asset_box text-2xl bg-classen__secondary classen__rounded flex items-center justify-center">
                <i class="fas fa-plus"></i>
              </div>
              <div
                class="mt-2 bg-classen__secondary rounded_full_50 add_product_box text-2xl flex items-center pl-6">
                <p><i class="fas fa-plus"></i></p>
                <p class="text-base ml-2">{{ getTranslation('addProduct') }}
                  ({{ getTranslation('optional') }})</p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-center">
          <button class="no_padding classen__button classen__rounded_full"
                  @click="state=1">
            {{ getTranslation('sendRequest') }}
          </button>
        </div>
      </div>

      <div v-if="state === 1" class="h-full w-full flex items-center justify-center py-10">
        <div class="">
          <p class="text-center mb-4 text-2xl">{{ getTranslation('confirmRequest') }}</p>
          <div class="flex justify-around">
            <button @click="cancelRequest" class="no_padding classen__button classen__rounded_full">
              {{ getTranslation('no') }}
            </button>
            <button @click="acceptRequest"
                    class="no_padding classen__button classen__rounded_full classen__button_active"
                    autofocus>
              {{ getTranslation('yes') }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="state === 2"
           class="h-full w-full text-2xl flex flex-col items-center justify-center">
        <p>{{ getTranslation('successfulRequest') }}</p>
        <p class="mb-4">{{ getTranslation('imagesInMailbox') }}</p>
        <div
          class="no_padding check check_mark flex items-center justify-center text-white text-base text-">
          <i class="fas fa-check"></i>
        </div>
        <button class="no_padding mt-2 classen__button classen__rounded_full hover__button h-"
                @click="$emit('close')">Ok
        </button>
      </div>
    </div>

    <c-template-picker v-if="isTemplatePickerVisible" @close="isTemplatePickerVisible = false"
                       :presets="hrImages"
                       @presetSelected="addPreset"/>
  </div>
</template>

<script>
import getTranslation from "../../../../../mixins/getTranslation";
import Input from "../../../../form/Input";
import CustomCheckbox from "../../../../form/CustomCheckbox";
import Select from "../../../../Select";
import ProductPicker from "../../../ProductPicker";
import TemplatePicker from "./TemplatePicker";

export default {
  name: "HRImagePopup",

  mixins: [getTranslation],

  props: {
    products: {required: true, type: Array},
    selection: {required: true}
  },

  components: {
    Select,
    'c-input': Input,
    'c-checkBox': CustomCheckbox,
    'c-product-picker': ProductPicker,
    'c-template-picker': TemplatePicker,
  },

  data() {
    return {
      purpose: '',
      selectedBevelColor: '',
      customerInter: '',
      res: 'FHD',
      md: 'web',
      isTemplatePickerVisible: false,
      orient: 'portrait',
      layingValue: 'floor',
      bevelNumber: '0V',
      bevelColors: [],
      templates: [],
      state: 0,
      loadingTemplates: false,
      performedValidation: false,
      hrImages: [],
    }
  },

  created() {
    this.getBevelColors();
    this.getHRImages();
  },

  destroyed() {

  },

  computed: {
    isValidPurpose() {
      return this.purpose.length > 0;
    },

    isValidCustomer() {
      return this.customerInter.length > 0;
    },

    isTemplatesValid() {
      return this.templates.length > 0
    },

    orientation: {
      get() {
        return this.orient;
      },

      set(value) {
        this.orient = value
      }
    },

    laying: {
      get() {
        return this.layingValue;
      },

      set(value) {
        this.layingValue = value
      }
    },

    bevel: {
      get() {
        return this.bevelNumber;
      },

      set(value) {
        this.bevelNumber = value
      }
    },

    resolution: {
      get() {
        return this.res;
      },

      set(value) {
        this.res = value
      }
    },

    media: {
      get() {
        return this.md;
      },

      set(value) {
        this.md = value
      }
    }
  },

  watch: {},

  methods: {
    addPreset(preset) {
      preset.products = [];
      this.templates.push(preset)
    },

    addProduct(template, event) {
      this.loadingTemplates = true;
      template.products.push(event);
      this.$nextTick(this.loadingTemplates = false)
    },

    delete_product(template, index) {
      this.loadingTemplates = true;
      let products = template.products
      products.splice(index, 1)
      this.$set(template, 'products', products)
      this.$nextTick(this.loadingTemplates = false)
    },

    cancelRequest() {
      this.state = 0
    },

    isValidRequest() {
      this.performedValidation = true;
      return this.isValidPurpose && this.isValidCustomer && this.isTemplatesValid
    },

    getHRImages() {
      this.$dashboardStore.dispatch('getHRImages', this.selection.id).then((res) => {
        this.hrImages = res;
      });
    },

    acceptRequest() {
      if (!this.isValidRequest()) {
        this.state = 0;
        return
      }

      let formattedTemplates = JSON.parse(JSON.stringify(this.templates));
      formattedTemplates.forEach((template) => {
        template.products = template.products.map((product) => product.id);
      });

      let imageRequest = {
        selectionId: this.selection.id,
        request: {
          media: this.media,
          resolution: this.resolution,
          orientation: this.orientation,
          purpose: this.purpose,
          laying: this.laying,
          bevel: this.bevel,
          bevelColor: this.selectedBevelColor,
          CustomerInternal: this.customerInter,
          templates: formattedTemplates,
        }
      }

      this.$dashboardStore.dispatch('requestImages', imageRequest).then((res) => {
        this.state = 2
      })
    },

    getBevelColors() {
      this.$dashboardStore.dispatch('getBevelColors').then((res) => {
        this.bevelColors = res
        this.selectedBevelColor = res[0].name
      })
    }
  }
}
</script>

<style scoped>
.option_item {
  height: 18px;
  line-height: 16px;
}

.asset_box {
  height: 200px;
  width: 285px
}

.add_product_box {
  height: 50px;
  width: 285px;
}

.no_padding {
  padding-left: 0px
}

.check {
  width: 25px;
  height: 25px;
  background-color: #DEB604
}

.header {
  height: 10%;
}

.small_header {
  height: 2%;
}

.content {
  height: calc(100% - 100px)
}

.template {
  width: 285px;
}

.delete {
  width: 30px;
  height: 30px;
  z-index: 50;
  margin-top: -35px;
  margin-left: 5px;
  margin-bottom: 5px;
  border-radius: 25px;
}

.delete_product {
  width: 30px;
  height: 30px;
  border-radius: 25px;
  margin-right: 15px;
}

.check_mark {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}
</style>
